export const GET_OFERTA_VIEW = 'GET_OFERTA_VIEW'
export const UPDATE_OFERTA_VIEW = 'UPDATE_OFERTA_VIEW'
export const DELETE_OFERTA_VIEW = 'DELETE_OFERTA_VIEW'
export const UPDATE_MY_BANKS = 'UPDATE_MY_BANKS'
export const UPDATE_BASIC_INFO = 'UPDATE_BASIC_INFO'
